module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-row clickable"
  }, [(_vm.editing) ? [_c('div', {
    staticClass: "table-col table-col-120"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('title')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "title",
      "type": "text"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })])])] : [_c('div', {
    staticClass: "table-col table-col-120"
  }, [_vm._v(_vm._s(_vm.lost_reason.title))])], _c('div', {
    staticClass: "table-col table-col-80"
  }, [(_vm.can_edit_lost_reason) ? _c('div', {
    staticClass: "pull-right"
  }, [(_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Salvar")]) : _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.editing = !_vm.editing
      }
    }
  }, [_vm._v(_vm._s(_vm.editing ? 'Cancelar' : 'Editar'))]), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroyLostReason
    }
  }, [_vm._v("Excluir")])]) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fd137e8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/lost_reason/list_item.vue
// module id = 1042
// module chunks = 1